module.exports = __webpack_public_path__ + "img/A3.10f73f9f.png";